import styled from 'styled-components';
import { darkgrey, inactive, newMark, white } from 'styles/Colors';

export const TeamSelectorWrapper = styled.div`
  position: relative;
  height: 45px;

  .react-autosuggest__container {
    position: absolute;
    background-color: ${white};
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
  }
  .autocomplete-input-label {
    width: 100%;
  }
  .react-autosuggest__input {
    font-family: Lato;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0.7px;
    border: none;
    margin-bottom: 0;
    display: block;
    width: 100%;
  }
  .react-autosuggest__input {
    height: 32px;
  }
  .react-autosuggest__input--focused {
    outline: none;
  }
  .react-autosuggest__container--open {
    z-index: 10;
  }
  .react-autosuggest__suggestions-container--open {
    display: block;
    background-color: ${white};
    font-family: Helvetica, sans-serif;
  }
  .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
    background-color: #fff;
    overflow-y: scroll;
    max-height: 210px;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
  .react-autosuggest__suggestion {
    cursor: default;
    pointer-events: none;
    div {
      cursor: pointer;
      pointer-events: all;
      padding: 8px 16px;
      p {
        margin: 0;
        padding: 0;
        color: ${darkgrey};
        font-size: 13px;
      }
      mark {
        padding: 0;
        background-color: ${newMark};
      }

      &.disabled {
        cursor: default;
        pointer-events: none;
        p {
          color: ${inactive};
        }
      }
    }
  }
  .react-autosuggest__suggestion--highlighted {
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.08);
  }
`;

export const SelectedTeam = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 700;
  line-height: 28px;

  svg {
    vertical-align: bottom;
    margin-left: 10px;
    width: 36px;
    height: 36px;
    margin-top: -10px;
  }
`;
